import { taxonomiesProjection } from '../Atoms/TaxonomiesById.query';

export const cardBlogProjection = `
  _id,
  _type,
  currentPathname,
  excludeFromInternalSearchAndResourceCenter,
  title,
  _type in ['lumaEvent', 'linkedEvent'] => {
    "title": name,
  },
  description,
  "cardImageRef": { 
      "_type": 'image',
      "asset": coalesce(cardImage.asset, genericCardImage.asset,baseCardImage.asset, heroImage.asset)
    },
  "cardImageAltText": coalesce(cardImage.asset, genericCardImage.asset, baseCardImage.asset, heroImage.asset)->altText,
  "cardImageSrc": coalesce(wistiaVideoMetadata.thumbnailUrl),
  "offSiteUrl": coalesce(url),
  slug,
  person {
    reference->,
  },
  cardButtonText,
  "articleDate": coalesce(articleDate, startDateTime),
  ${taxonomiesProjection},
`;

// used for torque queries, if you update this you made need to update SuggestedContent
export const cardBlog = groq`
*[ _id == $_id ][0] { ${cardBlogProjection} }
`;
